import React from 'react';
import preval from 'preval.macro';

import { VERSION } from '../config';

export const Version = () => {
    const date = preval`module.exports = new Date().toLocaleString();`;

    return (
        <div className="App">
            <header className="App-header">
                <p>
                    Build Date: {date}. Version: {VERSION}
                </p>
            </header>
        </div>
    );
};
